function ComponentChild(value) {
    return {
        type: "component",
        value
    };
}
function TextChild(value) {
    return {
        type: "text",
        value
    };
}
function isComponentChild(child) {
    return child.type === "component";
}
function isTextChild(child) {
    return child.type === "text";
}
function isHorizontalContainer(component) {
    var _a, _b;
    return (component.props.direction === "horizontal" ||
        typeof ((_a = component.props.className) === null || _a === void 0 ? void 0 : _a["flex-row"]) !== "undefined" ||
        typeof ((_b = component.props.className) === null || _b === void 0 ? void 0 : _b["flex-row-reverse"]) !== "undefined");
}
function getPagePathsById(appMeta) {
    const pagePathsById = {};
    const stack = appMeta.folderStructure.map((value) => ({
        item: value,
        runningPath: []
    }));
    while (stack.length > 0) {
        const curr = stack.pop();
        if (curr.item.type === "folder") {
            stack.push(...curr.item.children.map((value) => ({
                item: value,
                runningPath: [...curr.runningPath, curr.item.path]
            })));
            continue;
        }
        const path = [...curr.runningPath, curr.item.path].join("/");
        // we work with absolute paths for now so this should be okay
        pagePathsById[curr.item.id] = path.startsWith("/") ? path : "/" + path;
    }
    return pagePathsById;
}
const getSizeClassNamesFromClassName = (className, type) => {
    const classNames = className.split(" ");
    if (type === "width") {
        const widthClassNames = classNames.filter((value) => value.startsWith("w-"));
        return widthClassNames;
    }
    const heightClassNames = classNames.filter((value) => value.startsWith("h-"));
    return heightClassNames;
};

export { ComponentChild, TextChild, getPagePathsById, getSizeClassNamesFromClassName, isComponentChild, isHorizontalContainer, isTextChild };
//# sourceMappingURL=util.js.map
